import { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useWorkspace } from 'hooks/useWorkspace';

import ProductLibraryModal from 'Pages/TeamDashboard/ProductLibrary';

import { ROUTES } from 'routes/route.constants';

import styles from './styles.module.scss';

const DashboardHeader = ({
  onShowLowCreditsAlert,
  title = 'Dashboard',
  actionButton,
  isProductLibraryOpen: externalIsOpen,
  setIsProductLibraryOpen: externalSetOpen,
}) => {
  const navigate = useNavigate();
  const { isViewer } = useWorkspace();

  const [internalIsOpen, setInternalIsOpen] = useState(false);

  // Use external state if provided, otherwise use internal state
  const isProductLibraryOpen = externalIsOpen !== undefined ? externalIsOpen : internalIsOpen;
  const setIsProductLibraryOpen = externalSetOpen || setInternalIsOpen;

  const handleNewReview = () => {
    navigate(ROUTES.TEAM_REVIEWS_NEW);
  };

  const reviewCount = useSelector(state => state.designReview.reviewCount);
  const isLoadingReviewCount = useSelector(state => state.designReview.isLoadingReviewCount);

  const isDisabled = useMemo(
    // Disable button if loading or if reviews_remaining <= 1
    () => isLoadingReviewCount || (reviewCount?.reviews_remaining ?? 0) <= 1,
    [reviewCount, isLoadingReviewCount]
  );

  const handleDisabledButtonClick = () => {
    if (!isLoadingReviewCount && (reviewCount?.reviews_remaining ?? 0) <= 1 && onShowLowCreditsAlert) {
      onShowLowCreditsAlert();
    }
  };

  return (
    <>
      <header className="border-b border-gray-200 px-[16px] py-3">
        <div className="flex items-center justify-between h-10">
          <div className="flex items-center space-x-4">
            <h1 className="font-inter text-sm font-medium text-figma-gray-900 leading-5">
              {title}
            </h1>
          </div>

          <div className="flex items-center gap-16">
            <button
              className={styles['product-library-btn']}
              onClick={() => setIsProductLibraryOpen(true)}
            >
              Product library
            </button>

            {!isViewer && (actionButton ?? (
              <button
                onClick={isDisabled ? handleDisabledButtonClick : handleNewReview}
                className={`flex items-center justify-center px-3 py-2 font-inter text-sm font-medium rounded-lg
                  shadow-shadow-xs transition-colors ${isDisabled
                ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                : 'bg-primary-500 text-white hover:bg-primary-600'}`}
              >
                New audit
              </button>
            ))}
          </div>
        </div>
      </header>

      {isProductLibraryOpen && (
        <ProductLibraryModal onClose={() => setIsProductLibraryOpen(false)} />
      )}
    </>
  );
};

DashboardHeader.propTypes = {
  onShowLowCreditsAlert: PropTypes.func,
  title: PropTypes.string,
  actionButton: PropTypes.node,
  isProductLibraryOpen: PropTypes.bool,
  setIsProductLibraryOpen: PropTypes.func,
};

export default DashboardHeader;
